module.exports = __webpack_public_path__ + "img/google-maps.1d740ad2.png";